import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, RolePermissionData } from './types'

export const selectRolePermissionListEvent = (state: RootState): Event =>
  state.manageRolePermissionReducer.listEvent

export const selectRolePermissionList = (state: RootState): ListData => state.manageRolePermissionReducer.list

export const selectRolePermissionActionEvent = (state: RootState): Event =>
  state.manageRolePermissionReducer.actionEvent

export const selectAllRolePermissionList = (state: RootState): RolePermissionData[] =>
  state.manageRolePermissionReducer.allRolePermission

export const selectRefreshPermissionEvent = (state: RootState): Event =>
  state.manageRolePermissionReducer.refreshEvent
